import { err, ok } from 'neverthrow';

export default function urlFrom(u: string, base?: string) {
  try {
    return ok(new URL(u, base));
  } catch (_) {
    return err({ message: 'Invalid URL' as const });
  }
}
